import { create } from "zustand"

import { BalanceAdjustmentModalData } from "./types"

interface BalanceAdjustmentModalStore {
	isOpen: boolean
	data: BalanceAdjustmentModalData | null
	openModal: (data: BalanceAdjustmentModalData) => void
	closeModal: () => void
}

export const useBalanceAdjustmentModalStore =
	create<BalanceAdjustmentModalStore>(set => ({
		isOpen: false,
		data: null,

		openModal: (data: BalanceAdjustmentModalData) =>
			set({ isOpen: true, data }),

		closeModal: () => set({ isOpen: false, data: null }),
	}))
